var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from 'models/Model';
var Integration = /** @class */ (function (_super) {
    __extends(Integration, _super);
    function Integration() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Integration.prototype.getId = function () {
        return Number(this.id);
    };
    Integration.prototype.getName = function () {
        return this.name;
    };
    Integration.prototype.getDescription = function () {
        return this.description;
    };
    Integration.prototype.getEnabled = function () {
        return Boolean(this.enabled);
    };
    return Integration;
}(Model));
export default Integration;
